/* =============================================================================
Raw clues/answers, and picture ideas... use https://crosswordlabs.com/ to create
the crossword grid!

TWENTYFIFTH       Day of the month of Christmas
NINETEEN          Number of Christmases Jared and Barbara have been married
RUDOLPH           Name of red-nosed reindeer
WHITECHRISTMAS    Barbara’s must-see classic Christmas movie (starring Fred Astaire and Bing Crosby)
SKIING            Popular winter downhill sport that Jared learned in Japan
WINTERWONDERLAND  Chirstmas song that mentions a snowman “called Parson Brown”
FROSTY            Famous snowman with a corncob pipe and two eyes made out of coal
OLIVE             The “other” reindeer
BETHLEHEM         Little town that the silent stars go by
ADVENT            Countdown calendar for Christmas
============================================================================= */

// See the crossword README for the data format.
// These images are loaded via responsive-loader, which ensures our desired
// sizes.
import {
  SA_animals,
  SA_collage,
  redmond_snow,
  arizona,
  wildlife,
  cruise,
  balloon,
  friends,
  halloween,
  show_dogs,
} from './images';

const data = {
  across: {
    2: {
      answer: 'ADVENT',
      clue: 'Countdown calendar for Christmas',
      row: 3,
      col: 0,
      image: {
        data: SA_animals,
        title: 'Animals of South Africa',
        caption:
          'We fulfilled a dream in October of 2018: go on a safari! Well, we did not just one, but three, in South Africa with our dear friends and fellow travelers, Bill and Jean (our Ecuador and Galapagos travel co-adventurers). We spent nearly a month in the wilds of the continent that has more to offer than can be grasped in a lifetime. These images are only a speck of what we saw; there is such a rawness to Africa that it leaves you changed. This trip was the “straw that broke the camel’s back” for Barbara—it was the deciding factor for our move out of the city. Being able to enjoy the noise of the wild in the quietness of the world was deeply cherished. And while we are not as remote as we could be, or were in Africa, it is enough to give us the peace that we were craving. Come visit and hear Jared’s latest party trick: He communicates with hippos.',
      },
    },

    7: {
      answer: 'WINTERWONDERLAND',
      clue: 'Chirstmas song that mentions a snowman we can call Parson Brown',
      row: 7,
      col: 0,
      image: {
        data: cruise,
        title: 'Lee & Susan’s 50th Anniversary Cruise',
        caption:
          'Not too long after our move to AZ, we jetted off to Miami for a cruise with Jared’s family to celebrate Mom and Dad Reisinger’s 50th (FIFTIETH!!!) wedding anniversary. We gave ourselves an extra couple of days to explore South Miami Beach as a reward for surviving the move (and still liking and loving each other)! We had fun exploring the Art Deco world, stuffing ourselves on divine Cuban food, and taking in the scenery and sights at Fairchild Tropical Botanical Garden. We were rested and ready to party with the family! It was a great trip and it was wonderful to spend the time with family and celebrate two incredible individuals that are an inspiring couple. Thank you, Lee and Susan, for letting us celebrate you! We love you!',
      },
    },

    8: {
      answer: 'TWENTYFIFTH',
      clue: 'Day of the month of Christmas',
      row: 10,
      col: 1,
      image: {
        data: SA_collage,
        title: 'Our Trip to South Africa',
        caption:
          'There is a lot more to see and do in South Africa than safaris and we really didn’t do much more than safaris. But when we did, we had a great time with Bill and Jean. The flora and insects were as equally eye-catching as the fauna, including mountainous termite mounds. We visited Table Mountain (Barbara survived the open-air rotating cable-car ride) and pushed the edge at Victoria Falls (Barbara’s payback for that cable-car ride). Our trip to Cape of Good Hope gave us the “t-shirt” for visiting the southernmost points of the southern-hemisphere continents (except for the really, REALLY cold one). And yes, there are penguins in South Africa—little cute penguins—at Boulders Beach! Nearly every evening in South Africa concluded with a sundowner as we basked in the glow of the sunset.',
      },
    },

    10: {
      answer: 'OLIVE',
      clue: 'The “other” reindeer',
      row: 12,
      col: 7,
      image: {
        data: redmond_snow,
        title: 'Snow in Redmond',
        caption:
          'Our Redmond home sold in under 24 hours in the worst snowstorm on record. Barbara was in clear and sunny NYC for the Westminster Kennel Club Dog Show while Jared held down the frozen fort. The realtor was snowed-in at her own home, open houses were canceled, but in the chaos of the banks of white-frozen precipitation, house-hungry buyers showed up. We felt truly blessed to have sold our home of 22 years to a sweet family; may they enjoy the snow!',
      },
    },
  },
  down: {
    1: {
      answer: 'WHITECHRISTMAS',
      clue:
        'Barbara’s must-see classic Irving Berlin Christmas movie starring Bing Crosby, Danny Kaye, Rosemary Clooney, and Vera Ellen',
      row: 0,
      col: 5,
      image: {
        data: arizona,
        title: 'We Move to Arizona!',
        caption:
          'We have not regretted trading the rain, grey, and cold for sunshine and warm. With an underlying “itch” to get out of the Seattle-area insanity and less-than-ideal climate, we made the leap in March and survived the “dry heat” of our first Arizona summer without getting burned. Rest assured we are not alone—we have some incredible friends just down the road that we love getting together with for lots of fun! We are so delighted to call the beautiful SW our new home! Our speedy road-trip to our new home provided great opportunity to view some of our country’s gorgeous scenery (granted at a Reisinger-foot speed and no-stopping for pictures allowed—please forgive any blurriness). We are delighted to have fantastic mountain views from our roof-top patio (which is as close as any snow needs to come). The pups are entirely at home in the sunshine; Disa gave me a look the first morning in our new home, as she perched on the chair sunbathing, that said it all, “Mom, you FINALLY figured it out.” The boys have also relished the warmth and glow. We have really enjoyed the more “rural” lifestyle, having great sunrises and sunsets without the annoyance of neighbors being right on top of us. Our nearest neighbors are horses, which we thoroughly spoil with carrots! Clear, open, dark skies allow the stars to burst through and there has been plenty of meteor-shower viewing, too. These are some of the great qualities of the SW that Frank Lloyd Wright embraced at Taliesin West, which we were so delighted to share with Mom and Dad Reisinger and dear friends Bill and Jean. We are slowly taking in some of the sights of the greater-region; it’s hard to leave our home that we love so much, but in May, on advice from Bill, we visited Shiprock (a monadnock) in May—a great place to visit on a birthday! And what more could you ask for on a birthday than a great cocktail? Why, a prickly-pear margarita, of course! The abundance of fruit in the area screamed to be harvested, so now hauling prickly-pears back from Texas to Redmond is no longer necessary—we just step out our door. Come visit and enjoy a scratch made margarita with us in the garden that Barbara is busy creating! (Who knew you could need more boulders in the desert?)',
      },
    },

    3: {
      answer: 'SKIING',
      clue: 'Popular winter downhill sport that Jared learned in Japan',
      row: 3,
      col: 8,
      image: {
        data: wildlife,
        title: 'Wildlife in Arizona',
        caption:
          'From the creatures of Africa to the creatures of Arizona, there is never a dull moment in wildlife watching at our new home. We have a feather-filled array of various birds from raptors to quail to roadrunners. There are the bobcats and coyotes that have visited, and there is a mountain lion not too far away (and can stay away). We also get to enjoy some of the creepy-crawlies of the desert (the tarantula is a friend, folks—it eats scorpions, which are not our friends). Reptiles of various sorts make themselves present on a semi-regular basis and it is a constant education in the world of herpetology. We are taking significant measures to ensure the safety of the dogs and as result, the safety of the desert dwellers, too. Jared would probably consider the “pokey-plants” wildlife, too, as they always seem to be out to get him. However, he is not the one that had the ER visit to remove an agave spike from between a knuckle joint, so it is Barbara’s word whether these beauties of the flora world should be classified as wildlife; they absolutely should not be—Jared just needs to watch out! HA!',
      },
    },

    4: {
      answer: 'RUDOLPH',
      clue: 'Name of red-nosed reindeer',
      row: 3,
      col: 12,
      image: {
        data: balloon,
        title: 'Hot-Air Balloon Ride',
        caption:
          'Our dear friends and travel buddies from Washington, Bill and Jean, came for a very nice visit in October. We explored some of the area’s landmarks, including the Wrigley Mansion, visited the Desert Botanical Garden (where Barbara has been having fun taking classes), and lifted-off for Bill and Jean’s first hot-air balloon ride. We had a wonderful time and look forward to our next adventure (sneak-peak: Costa Rica)!',
      },
    },

    5: {
      answer: 'BETHLEHEM',
      clue: 'Little town that the silent stars go by',
      row: 5,
      col: 3,
      image: {
        data: friends,
        title: 'Visiting Friends',
        caption:
          'Barbara made a few trips to the PNW working towards a couple of goals for Duke, the Basenji Special she shows, and while there she made sure to visit with friends, including Bill and Jean.',
      },
    },

    6: {
      answer: 'NINETEEN',
      clue: 'Number of Christmases Jared and Barbara have been married',
      row: 6,
      col: 1,
      image: {
        data: halloween,
        title: 'Halloween',
        caption:
          'The town of Carefree is our closest town and we have adopted it as “our town” even if our address does not reflect it. It has our favorite coffee café, butcher shop—conveniently located next door to our favorite wine café and store—and boasts one of the largest sundials in the United States. Each fall, Carefee hosts Enchanted Pumpkin Garden featuring incredible scenes of carved pumpkins, world-renown pumpkin carvers, and a couple of goofy people.',
      },
    },

    9: {
      answer: 'FROSTY',
      clue: 'Famous snowman with a corncob pipe and two eyes made out of coal',
      row: 10,
      col: 7,
      image: {
        data: show_dogs,
        title: 'Show Dogs!',
        caption:
          'We have been so very richly blessed to have met and made some incredible friends from the dog community. 2018 was a spectacular year for Barbara and Duke, the Basenji Special that is owned by our friend Steve. Purely organically, with no purposeful campaigning, Barbara and Duke climbed the ranks to end the year as #1 male Basenji and #2 overall Basenji in the breed rankings. They sweeped the prestigious Everygreen Basenji Club Specialties, including the 50th Anniversary celebration, and went on to gather multiple group placements and participate at the AKC National Championship. The long hours and hard work paid off, and with their ranking they were invited to participate at the Westminster Kennel Club Dog Show, taking the 1st Award of Merit and cheering on their friend in the Group ring to be the first Basenji to place in group in 45 years. It is a true gift to be able to compete together in the ring and then cheer fellow competitors on as they continue. This March was the final time that the Seattle Kennel Club would host their show and community event at the downtown location in Seattle. This two-day dog extravaganza kept us hopping as we managed the website, social media, and demo rings. We will dearly miss that event and the joy that we shared with the community, but have high hopes of delving into and developing a similar family here in Arizona. Our own pups, Disa, Spyros, and Gable, constantly make us laugh, scratch our head, and surprise us with special antics. They are busy in their own sports: hunting rats, scenting birch, chasing lure, and working the ring, but at the end of the day they are the most wonderful bed-hogs in the world. Spyros became a “daddy” this year and we are very excited to see how his progeny develop. Dog events can take you many places, introduce you to many people, and enrich your life in ways unimaginable. We feel very fortunate to have friends we consider family from this community.',
      },
    },
  },
};

export default data;
